import useLocalStorage from "./useLocalStorage";
import {useRef} from "react";

import "../App.scss"
import FilterList from "./filterList";
import SearchBar from "./searchBar";
import ResultItems from "./resultItems";
import StatusBar from "./statusBar";

export default function HomePage(props) {

  const input_search_ref = useRef();

  // We ue useLocalStorage for those values we need after clicking "go back" button (detail page)
  const [filterList, setFilterList] = useLocalStorage("filter_list_key", null);
  const [tags, setTags] = useLocalStorage("tags_key", {});
  const [search, setSearch] = useLocalStorage("search_key", null);
  const [currentPage, setCurrentPage] = useLocalStorage("page_key", 0);
  const [hiddenFilters, setHiddenFilters] = useLocalStorage("hidden_filters", []);

  return (
    <div className="body">
      <div className="filters col">
        <FilterList
          filterList={filterList}
          tags={tags}
          setTags={setTags}
          search={search}
          setCurrentPage={setCurrentPage} // in order to reset to CERO on change filters
          setHiddenFilters={setHiddenFilters} // In order to SAVE hidden filters for rendering when back button
          hiddenFilters={hiddenFilters} // Get the array to push new HIDDEN ones...
        />
      </div>
      <div className="content col">
        <SearchBar
          setSearch={setSearch}
          search={search}
          setCurrentPage={setCurrentPage}
          setTags={setTags}
          setHiddenFilters={setHiddenFilters}
          searchRef={input_search_ref}
        />
        <StatusBar
          search={search} // We print in status what word is currently searching for...
          setSearch={setSearch}
          tags={tags}
          setTags={setTags}
          setCurrentPage={setCurrentPage}
          // We also pass filterList as we NEED the MAP key/names for them...
          filterList={filterList}
          setHiddenFilters={setHiddenFilters} // In order to SAVE hidden filters for rendering when back button
          hiddenFilters={hiddenFilters} // Get the array to push new HIDDEN ones...
          searchRef={input_search_ref}
        />
        <ResultItems
          search={search}
          tags={tags}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          remoteApiUrlBase={props.baseApiUrl}
          setFilterList={setFilterList}
        />
      </div>
    </div>
  );
}